import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { projectSettingsModalHide } from "../../redux/counterSlice";
import {createPledge} from "../../utils/api";
import Spinner from "../Spinner";
import {Alert} from "@mui/material";

const ProjectSettingsModal = () => {
  const { projectSettings, projectData } = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isAvailableForSale, setIsAvailableForSale] = useState(false);
  const [floorPrice, setFloorPrice] = useState(1); // State for CADRs amount
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  
  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        setSuccessMessage(""); // Clear the success message after 5 seconds
      }, 5000);

      return () => clearTimeout(timer); // Clear the timer on component unmount
    }
  }, [successMessage]);
  
  const handleIsAvailableForSaleChange = (event) => {
    setIsAvailableForSale(event.target.checked);
  };
  
  async function handleSubmit(e) {
    e.preventDefault();
    setIsButtonDisabled(true);
    setIsLoading(true); // Show spinner
    try {
      const response = await createPledge({
        projectId: projectData.projectId,
        cadrsPledged: Number(floorPrice), // Use the state variable here
      });

      setSuccessMessage("Project Settings saved!");
    } catch (error) {
      console.error("Error saving settings:", error);
    } finally {
      setIsButtonDisabled(false);
      setIsLoading(false); // Hide spinner
    }
  }

  function handleFloorPriceChange(e) {
    setFloorPrice(e.target.value); // Update the state with input value
  }

  return (
      <div>
        <div className={projectSettings ? "modal fade show block" : "modal fade"}>
          <div className="modal-dialog max-w-2xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="projectSettingsModalLabel">
                  Settings
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => dispatch(projectSettingsModalHide())}
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                  >
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"/>
                  </svg>
                </button>
              </div>
              <div className="modal-body p-6">
                {/* <!-- Unlockable Content --> */}
                <div className="dark:border-jacarta-600 border-jacarta-100 relative border-b py-6">
                  <div className="flex items-center justify-between">
                    <div className="flex">
                      
                      <div>
                        <label className="font-display text-jacarta-700 block dark:text-white">
                          Make Available for Sale
                        </label>
                        <p className="dark:text-jacarta-300 pr-5">
                          to other registry accounts
                        </p>
                      </div>
                    </div>
                    <input
                        type="checkbox"
                        checked={isAvailableForSale}
                        onChange={handleIsAvailableForSaleChange}
                        value="checkbox"
                        name="check"
                        className="checked:bg-accent checked:focus:bg-accent checked:hover:bg-accent after:bg-jacarta-400 bg-jacarta-100 relative h-6 w-[2.625rem] cursor-pointer appearance-none rounded-full border-none after:absolute after:top-[0.1875rem] after:left-[0.1875rem] after:h-[1.125rem] after:w-[1.125rem] after:rounded-full after:transition-all checked:bg-none checked:after:left-[1.3125rem] checked:after:bg-white focus:ring-transparent focus:ring-offset-0"
                    />
                  </div>
                </div>
                <div className="mb-2 flex items-center justify-between">
              <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                Price
              </span>
                </div>

                <div
                    className="dark:border-jacarta-600 border-jacarta-100 relative mb-2 flex items-center overflow-hidden rounded-lg border">
                  <div className="border-jacarta-100 bg-jacarta-50 flex flex-1 items-center self-stretch border-r px-2">
                <span className="font-display text-jacarta-700 text-sm">
                    $ USD
                  </span>
                  </div>

                  <input
                      type="number"
                      className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                      placeholder="Amount"
                      value={floorPrice} // Bind the state to input
                      onBlur={() => {
                        if (floorPrice < 1) {
                          setFloorPrice(1);
                        }
                      }}
                      onChange={handleFloorPriceChange} // Update state on change
                  />
                </div>
              </div>

              <div className="modal-footer">
                <div className="flex items-center justify-center space-x-4">
                  <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={isButtonDisabled}
                      className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                  >
                    {isLoading ? (
                        <div className="flex items-center justify-center">
                          <Spinner/> {/* Display the spinner component */}
                          <span className="ml-2">In progress...</span>
                        </div>
                    ) : (
                        "Save"
                    )}
                  </button>
                </div>
              </div>
              {successMessage && (
                  <Alert severity="success">
                    {successMessage}
                  </Alert>
              )}
            </div>

          </div>
        </div>
      </div>
  )
      ;
};

export default ProjectSettingsModal;